export enum SogDropDownButtonType {
  Default,
  Appbar,
  Card
}
